import { render, staticRenderFns } from "./m-history-form.vue?vue&type=template&id=4b248e6d&scoped=true&"
import script from "./m-history-form.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-history-form.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-history-form.vue?vue&type=style&index=0&id=4b248e6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b248e6d",
  null
  
)

export default component.exports